import { render, staticRenderFns } from "./GerenciaCadastroQhPrevisoes.vue?vue&type=template&id=6c21960e&scoped=true"
import script from "./GerenciaCadastroQhPrevisoes.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroQhPrevisoes.vue?vue&type=script&lang=js"
import style0 from "./GerenciaCadastroQhPrevisoes.vue?vue&type=style&index=0&id=6c21960e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c21960e",
  null
  
)

export default component.exports